// lineHelpers.js

export function computeLines(bracketData, matchRefs, rect) {
  const newLines = [];

  if (!bracketData?.rounds) return newLines;

  bracketData.rounds.forEach((round, roundIndex) => {
    if (roundIndex === 0) return;

    round.forEach((match) => {
      const targetEl = matchRefs.current[match.matchId];

      if (!targetEl) return;

      const targetRect = targetEl.getBoundingClientRect();

      const targetX = targetRect.left - rect.left;

      const targetY =
        targetRect.top +
        targetRect.height / 2 -
        rect.top;

      const parentPoints = [];

      ["teamA", "teamB"].forEach((slot) => {
        const sourceId = match[slot]?.sourceMatchId;

        if (!sourceId) return;

        const sourceEl = matchRefs.current[sourceId];

        if (!sourceEl) return;

        const sourceRect = sourceEl.getBoundingClientRect();

        parentPoints.push({
          x:
            sourceRect.right -
            rect.left,
          y:
            sourceRect.top +
            sourceRect.height / 2 -
            rect.top,
        });
      });

      // Two parent matches
      if (parentPoints.length === 2) {
        const sourceX =
          Math.max(
            parentPoints[0].x,
            parentPoints[1].x
          );

        // Dynamic midpoint between rounds
        const junctionX =
          sourceX + (targetX - sourceX) / 2;

        const yTop = Math.min(
          parentPoints[0].y,
          parentPoints[1].y
        );

        const yBottom = Math.max(
          parentPoints[0].y,
          parentPoints[1].y
        );

        // Parent horizontal lines
        parentPoints.forEach((parent) => {
          newLines.push({
            x1: parent.x,
            y1: parent.y,
            x2: junctionX,
            y2: parent.y,
          });
        });

        // Vertical connector
        newLines.push({
          x1: junctionX,
          y1: yTop,
          x2: junctionX,
          y2: yBottom,
        });

        // Connector to child
        newLines.push({
          x1: junctionX,
          y1: targetY,
          x2: targetX,
          y2: targetY,
        });
      }

      // One parent match
      else if (parentPoints.length === 1) {
        const parent = parentPoints[0];

        newLines.push({
          x1: parent.x,
          y1: parent.y,
          x2: targetX,
          y2: targetY,
        });
      }
    });
  });

  return newLines;
}